import moment from 'moment';

const users = {
  continued(user) {
    return moment().diff(moment(user.registered_at), 'day');
  }
};

export default users;